export class HeaderService {

  userName: string;

  getUserName() {
    this.userName = localStorage.getItem('user');
    return this.userName;
  }

}
